import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 lg:px-8 py-20">
        <Button variant="ghost" asChild className="mb-8 gap-2">
          <Link to="/">
            <ArrowLeft className="h-4 w-4" />
            Zurück zur Startseite
          </Link>
        </Button>
        
        <div className="max-w-3xl">
          <h1 className="font-display text-4xl font-bold text-foreground mb-8">
            Impressum
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-muted-foreground mb-4">
              Lack Zentrum Wilke GmbH<br />
              Silberbergweg 30<br />
              39128 Magdeburg
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              Kontakt
            </h2>
            <p className="text-muted-foreground mb-4">
              Telefon: 0391 635 771 15<br />
              Telefon: 0391 635 772 22<br />
              E-Mail: info@lackzentrum-wilke.com
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              Vertreten durch
            </h2>
            <p className="text-muted-foreground mb-4">
              [Geschäftsführer Name - Platzhalter]
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              Registereintrag
            </h2>
            <p className="text-muted-foreground mb-4">
              Eingetragen im Handelsregister<br />
              Registergericht: Amtsgericht Magdeburg<br />
              Registernummer: [HRB-Nummer - Platzhalter]
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              Umsatzsteuer-ID
            </h2>
            <p className="text-muted-foreground mb-4">
              Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
              [USt-IdNr. - Platzhalter]
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              Berufsbezeichnung und berufsrechtliche Regelungen
            </h2>
            <p className="text-muted-foreground mb-4">
              Berufsbezeichnung: Fahrzeuglackierer / Karosseriebauer<br />
              Zuständige Kammer: Handwerkskammer Magdeburg
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              Streitschlichtung
            </h2>
            <p className="text-muted-foreground mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="text-muted-foreground mb-4">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              Haftung für Inhalte
            </h2>
            <p className="text-muted-foreground mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen 
              Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir 
              als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
              Tätigkeit hinweisen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
